import React, {SyntheticEvent, KeyboardEvent} from 'react';
import {Tabs, Tab, Box} from '@mui/material';
import './JobResultTabs.scss';

export interface TabConfig {
  label: string;
  component: React.ReactNode;
  disabled?: boolean;
}

export interface JobResultTabsProps {
  value: number;
  onChange: (event: SyntheticEvent, value: number) => void;
  tabs: TabConfig[];
}

const a11yProps = (index: number) => ({
  id: `job-result-tab-${index}`,
  'aria-controls': `job-result-tabpanel-${index}`,
});

const JobResultTabs = ({value, onChange, tabs}: JobResultTabsProps) => {
  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter') {
      event.stopPropagation();
    }
  };

  return (
    <Box className="arr-header-tab-container">
      <Tabs value={value} onChange={onChange} className="arr-header-tabs tab">
        {tabs.map((tab, index) => (
          <Tab
            key={`tab-${index}`}
            label={tab.label}
            // disabled // enabled for demo purpose
            disabled={tab.disabled}
            className="typo-text subhead4_size arr-header-tab-text"
            onKeyDown={handleKeyDown}
            {...a11yProps(index)}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default JobResultTabs;
